import { render } from "./EditFoodView.vue?vue&type=template&id=28c920f0"
import script from "./EditFoodView.vue?vue&type=script&lang=js"
export * from "./EditFoodView.vue?vue&type=script&lang=js"

import exportComponent from "C:\\WORK\\Tamani\\admin-landing\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__